// The signed-in person's roles, turned into the labelled chips shown under the
// sidebar logo. A pure function of grants, so the wording lives in one place
// and is tested without mounting the layout.

import type { AppRole, RoleGrant } from '../types'

export type RoleChipKind = 'platform' | 'reporting' | 'user'

export interface RoleChip {
  label: string
  kind: RoleChipKind
}

/**
 * Grants -> the chips beside the logo, most privileged first. PlatformAdmin
 * implies every other role, so it shows alone. Someone with no admin role gets
 * a single "User" chip (they view and edit, but administer nothing), so
 * everyone can see where they stand.
 */
export function roleChips(grants: RoleGrant[] | undefined): RoleChip[] {
  const has = (role: AppRole) => (grants ?? []).some(grant => grant.role === role)
  if (has('PlatformAdmin')) return [{ label: 'Platform admin', kind: 'platform' }]
  if (has('StatusReportingAdmin')) return [{ label: 'Status reporting admin', kind: 'reporting' }]
  if (has('SurveyAdmin')) return [{ label: 'Survey admin', kind: 'reporting' }]
  if (has('SurveyResults')) return [{ label: 'Survey results', kind: 'reporting' }]
  return [{ label: 'User', kind: 'user' }]
}
